import React from 'react';

import RichTextEditor from '../../../../../../../common/react/components/rich-text-editor';

import FormActions from '../../../../shared/actions/form';
import Localization from '../../../../../../../common/edlio-js/models/BackendLocalization';

export default class TextBoxElement extends React.Component {
	constructor(props) {
		super(props);

		this.localization = new Localization(window.edlio.localizations);
	}

	getHTMLOutput(content) {
		return {
			__html: content
		}
	}

	handleBlur(event) {
		const {
			fieldsetIndex,
			rowIndex,
			index
		} = this.props;

		const rteContent = event.target.getContent();

		this.setState({ content: rteContent });

		FormActions.saveRichText(fieldsetIndex, rowIndex, index, rteContent);
	}

	render() {
		const { content, editModeEnabled } = this.props.data;
		const { localization } = this;

		return (
			<div className='text-box'>
				<div style={{ display: editModeEnabled ? null : 'none' }}>
					<RichTextEditor
						initialValue={localization.localize(content)}
						autoResize
						stickyToolbar
						onBlur={this.handleBlur.bind(this)}
					/>
				</div>

				<div
					style={{ display: editModeEnabled ? 'none' : null }}
					className='rte-output'
					dangerouslySetInnerHTML={this.getHTMLOutput(content)}
				/>
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/main/webapps/features/form-builder/react/editor/components/form-elements/extras/text.js